export default {
  CLOSED: 0,
  VIEW: 1,
  ADD: 2,
  EDIT: 3,
  PREVIEW_EXISTING: 4,
};
